import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { formatBarcode } from "../../utils/utils";
import editIcon from "../../assets/images/edit-icon.svg";
import dateEditIcon from "../../assets/images/date-edit-icon.svg";
import timeEditIcon from "../../assets/images/time-edit-icon.svg";

const ATTEMPT_OPTIONS = [1, 2];

const renderEditor = (field, value, onUpdate) => {
  const update = (newValue) => onUpdate?.(field.name, newValue);

  switch (field.editType) {
    case "barcode":
      return (
        <div className="detail-card__input-wrapper">
          <input
            className="detail-card__input"
            type="text"
            value={value || ""}
            onChange={(e) => update(e.target.value)}
            onBlur={(e) => update(formatBarcode(e.target.value))}
          />
          <img
            className="detail-card__input-icon"
            src={editIcon}
            alt=""
            aria-hidden="true"
          />
        </div>
      );
    case "date": {
      const parsed = moment(value, ["DD/MM/YYYY", "YYYY-MM-DD"], true);
      return (
        <div className="detail-card__input-wrapper">
          <DatePicker
            className="detail-card__input detail-card__input--picker"
            dateFormat="dd/MM/yyyy"
            selected={parsed.isValid() ? parsed.toDate() : null}
            onChange={(date) =>
              update(date ? moment(date).format("YYYY-MM-DD") : "")
            }
          />
          <img
            className="detail-card__input-icon"
            src={dateEditIcon}
            alt=""
            aria-hidden="true"
          />
        </div>
      );
    }
    case "time":
      return (
        <div className="detail-card__input-wrapper">
          <input
            className="detail-card__input detail-card__input--picker"
            type="time"
            value={value || ""}
            onChange={(e) => update(e.target.value)}
          />
          <img
            className="detail-card__input-icon"
            src={timeEditIcon}
            alt=""
            aria-hidden="true"
          />
        </div>
      );
    case "attempts":
      return (
        <div className="detail-card__radio-group" role="radiogroup">
          {ATTEMPT_OPTIONS.map((num) => (
            <label className="detail-card__radio" key={num}>
              <input
                type="radio"
                name={field.name}
                value={num}
                checked={String(value) === String(num)}
                onChange={(e) => update(e.target.value)}
              />
              <span>{num}</span>
            </label>
          ))}
        </div>
      );
    default:
      return (
        <input
          className="detail-card__input"
          type="text"
          value={value || ""}
          onChange={(e) => update(e.target.value)}
        />
      );
  }
};

const DetailCard = ({ heading, data, fields, editable, onUpdate }) => {
  return (
    <div className="detail-card">
      <h3 className="detail-card__heading">{heading}</h3>

      <div className="detail-card__details">
        {fields.map((field) => {
          const isEditing = editable && field.editType;
          return (
            <div
              className={`detail-card__item ${isEditing ? "detail-card__item--editing" : ""}`}
              key={field.name}
            >
              <span className="detail-card__label">{field.label}:</span>

              {isEditing ? (
                renderEditor(field, data?.[field.name], onUpdate)
              ) : (
                <span className={`detail-card__value ${field.className}`}>
                  {data?.[field.name] || "-"}
                </span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

DetailCard.propTypes = {
  heading: PropTypes.string.isRequired,
  data: PropTypes.object,
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      editType: PropTypes.oneOf(["text", "barcode", "date", "time", "attempts"]),
    }),
  ).isRequired,
  editable: PropTypes.bool,
  onUpdate: PropTypes.func,
};

DetailCard.defaultProps = {
  data: {},
  editable: false,
  onUpdate: undefined,
};

export default DetailCard;
